export enum ErrorTypeEnum {
  UNKNOWN,
  PRESCRIPTION_RECIPE,
  PRESCRIPTION_HELENA,
  ATTESTATION_HELENA
}

export interface ErrorType {
  readonly message: string;
  readonly type: ErrorTypeEnum;
}

export class Error implements ErrorType {
  readonly message: string;
  readonly type: ErrorTypeEnum;

  constructor(data?: ErrorType) {
    this.message = "";
    this.type = ErrorTypeEnum.UNKNOWN;
    if (data) {
      Object.assign(this, data);
    }
  }
}
